<template>
  <div class="question-view">
    <div v-if="question">
      <Question
        :question="question"
        @answered="handleAnswer(true)"
        @failed="handleAnswer(false)"
      />
    </div>
    <div v-else class="question-input-container">
      <p>Frage-ID eingeben um direkt eine Frage zu laden</p>
      <div class="question-id-input-container">
        <input
          v-model="questionId"
          type="number"
          placeholder="Fragen-ID eingeben"
          @keydown.enter="goto(questionId)"
        />
        <BaseButton @click="goto(questionId)">Laden</BaseButton>
      </div>
      <div v-if="error" class="error">
        Beim Laden dieser Frage ist ein Problem aufgetreten.<br />Möglicherweise
        existiert diese Frage nicht.
      </div>
      <div v-if="questions.length > 0" class="question-log-container">
        <h2>Log</h2>
        <table v-if="questions" class="question-log">
          <thead>
            <tr>
              <th class="q-id">#</th>
              <th>Frage</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(q, index) in questions"
              :key="index"
              @click="loadQuestion(q.id)"
            >
              <td class="q-id">{{ q.id }}</td>
              <td>{{ q.text.DE.question_text }}</td>
              <td :class="q.correct ? 'correct' : 'false'"><div /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "@/components/Question.vue";
import BaseButton from "@/components/BaseButton.vue";
import axios from "@/http";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "QuestionView",
  components: {
    Question,
    BaseButton,
  },
  data() {
    return {
      questionId: null,
      question: null,
      questions: [],
      error: false,
    };
  },
  computed: {
    ...mapGetters(["tokenHeader"]),
  },
  watch: {
    "$route.params.question_id": function (id) {
      if (id) {
        this.loadQuestion(id);
      }
    },
  },
  async mounted() {
    this.setPageType("question");
    if (this.$route.params) {
      if (this.$route.params.question_id) {
        this.questionId = this.$route.params.question_id;
        this.loadQuestion(this.questionId);
      }
    }
  },
  methods: {
    goto(id) {
      this.$router.push("/frage/" + id);
    },
    async loadQuestion(id) {
      this.error = false;
      try {
        let result = await axios.get(
          process.env.VUE_APP_FLL_ROOT_API + "/questions/" + id,
          {
            headers: {
              ...this.tokenHeader,
            },
          }
        );
        this.question = result.data;
        this.key = Math.random();
      } catch (error) {
        this.error = true;
        console.error(error);  // eslint-disable-line
      }
    },
    handleAnswer(correct) {
      this.question.correct = correct;
      this.questions.push(this.question);
      if (correct && this.question.follow_up_question) {
        this.$router.push("/frage/" + this.question.follow_up_question.id);
      } else {
        this.question = null;
        this.questionId = null;
        this.$router.push("/frage");
      }
    },
    ...mapActions(["setPageType"]),
  },
};
</script>

<style lang="scss" scoped>
.question-view {
  .question-input-container {
    padding: 10px;
    .question-id-input-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;

      input {
        margin-right: 10px;
        color: #000000;
        padding: 10px;
      }
    }
    h2 {
      color: #000000;
    }
    table {
      margin-top: 20px;
      border-collapse: collapse;

      tr {
        cursor: pointer;
        th {
          text-align: left;
          font-weight: bold;
          border-bottom: 2px solid $blue;
        }
        td,
        th {
          color: #000000;
          vertical-align: top;
          padding: 4px 2px;
        }
        td {
          border-bottom: 1px solid $blue;

          &.correct {
            div {
              width: 15px;
              height: 15px;
              background: #00ff00;
              border: 1px solid #fff;
            }
          }
          &.false {
            div {
              width: 15px;
              height: 15px;
              background: #ff0000;
              border: 1px solid #fff;
            }
          }
        }
        .q-id {
          text-align: right;
          padding-right: 10px;
        }
        &:hover {
          td {
            background: $green;
            color: #ffffff;
          }
        }
      }
    }
  }

  .error {
    border: 1px solid #ff0000;
    padding: 10px;
    color: #ff0000;
    text-align: center;
  }
}
</style>
